import { useEffect, useState, useCallback } from 'react';
import type { DocumentListItem, ProjectChatItem, ProjectFileItem } from '../../../services/api';
import { projectsApi } from '../../../services/api';

interface UseProjectResourcesResult {
  documents: DocumentListItem[];
  chats: ProjectChatItem[];
  files: ProjectFileItem[];
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useProjectResources(): UseProjectResourcesResult {
  const [documents, setDocuments] = useState<DocumentListItem[]>([]);
  const [chats, setChats] = useState<ProjectChatItem[]>([]);
  const [files, setFiles] = useState<ProjectFileItem[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const summary = await projectsApi.getResourcesSummary();
      setDocuments(summary.documents);
      setChats(summary.chats);
      setFiles(summary.files);
    } catch (error) {
      console.error('Error loading project resources summary:', error);
      setDocuments([]);
      setChats([]);
      setFiles([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { documents, chats, files, loading, refresh };
}
